// Re-render on any style write for the selected node.
//
// The node is a plain (non-Vue-reactive) Konva instance by design — see
// ConfigManager's markRaw() on styleResolver — so a style change never
// invalidates a render on its own. PartPropertiesPanel already solves this for
// its own part by subscribing to that part's style-refresh events; the panels
// that only show *derived* status (the accordion modified indicators) need the
// same signal across every part, hence this shared mixin.
//
// `styleTick` is never read for its value, only referenced to register as a
// render dependency.
export const styleRefreshMixin = {
    data() {
        return { styleTick: 0 };
    },

    mounted() {
        this.subscribeStyleRefresh();
    },

    beforeUnmount() {
        this.unsubscribeStyleRefresh();
    },

    watch: {
        // Selection changes swap the node out from under the subscriptions.
        node() {
            this.unsubscribeStyleRefresh();
            this.subscribeStyleRefresh();
        },
    },

    methods: {
        subscribeStyleRefresh() {
            const node = this.node;
            this._styleRefreshSubs = [];
            if (!node?.onStyle) return;
            for (const part of node.getPartNames?.() ?? []) {
                for (const prop of Object.keys(node.getStyleDefinition(part)?.properties ?? {})) {
                    const handler = () => { this.styleTick++; };
                    node.onStyle(part, prop, handler);
                    this._styleRefreshSubs.push({ node, part, prop, handler });
                }
            }
        },

        unsubscribeStyleRefresh() {
            for (const { node, part, prop, handler } of this._styleRefreshSubs ?? []) {
                node.offStyle?.(part, prop, handler);
            }
            this._styleRefreshSubs = [];
        },
    },
};
